export default {"src":"/_next/static/media/icon-search.daaf6ac9.svg","height":13,"width":12,"blurWidth":0,"blurHeight":0};